import React, {useState} from "react";
import Datetime from "react-datetime";
import moment from "moment";
import "moment/locale/ja";
import "react-datetime/css/react-datetime.css";
import calendarIcon from "../../../assets/icons/calendar-icon.png";
import { FiX } from "react-icons/fi";
import {enterFocus} from "../../../utils";
import tenkenTheme from "../../../configs/themes/tenkenTheme";
import { Button } from "flowbite-react";

moment.locale("ja");

const DatetimePicker = ({
  name,
  id,
  value,
  className,
  onChange,
  disabled = false,
  readOnly = true,
  hasError = false,
  maxLength,
  showClearButton = false,
  nextFocus = '',
  autoFocus,
  ...rest
}) => {
  const handleChange = (date) => {
    if (moment.isMoment(date)) {
      if (rest.timeFormat === false) {
        onChange(name, date.format("YYYY/MM/DD"));
        return;
      }
      onChange(name, date.format("YYYY/MM/DD HH:mm"));
    }
    let momentDate = moment(date);
    if (momentDate.isValid()) {
      if (rest.timeFormat === false) {
        onChange(name, momentDate.format("YYYY/MM/DD"));
        return;
      }
      onChange(name, momentDate.format("YYYY/MM/DD HH:mm"));
      return;
    }
    onChange(name, date);
  };
  const readOnlyClass = "";
  const disabledClass = "disabled:bg-gray-200 disabled:cursor-not-allowed disabled:text-[#989898]";
  const borderClass = hasError === false ? "border-tenken-gray-500" : "border-red-500";
  const initialInputClass = 'focus:bg-yellow-100 focus:ring-transparent focus:border-gray-500 lg:h-[40px] h-[38px] lg:text-base text-[15px] hover:cursor-pointer placeholder:text-gray-400';
  const backgroundColor = disabled === true ? disabledClass : "bg-white";
  const inputClass = `${readOnlyClass} ${initialInputClass} ${backgroundColor} border ${borderClass} rounded-[6px] p-2 ${className || ""}`;

  const renderInput = (props) => {
    let inputValue = '';
    if (value) {
      if (moment.isMoment(value)) {
        if (rest.timeFormat === false) {
          inputValue = value.format("YYYY/MM/DD");
        } else {
          inputValue = value.format("YYYY/MM/DD HH:mm");
        }
      }
      let momentDate = moment(value);
      if (momentDate.isValid()) {
        if (rest.timeFormat === false) {
          inputValue = momentDate.format("YYYY/MM/DD");
        } else {
          inputValue = momentDate.format("YYYY/MM/DD HH:mm");
        }
      }
    }
    const inputProps = {
      ...props,
      value: inputValue,
      onChange: props.onChange,
      onFocus: props.onFocus,
      onBlur: props.onBlur,
      onKeyDown: props.onKeyDown,
    };
    return (
      <div>
        <input {...inputProps}/>
        {showClearButton && value && (
          <button className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-transparent border-none text-gray-400 hover:text-gray-600 focus:outline-none">
            <FiX className="font-bold mr-[24px]" size={16} onClick={() => onChange(name, null)} />
          </button>
        )}
      </div>
    )
  };

  const [key, setKey] = useState(0);
  const handleSetToday = () => {
    const today = new Date();
    let momentDate = moment(today);
    if (rest.timeFormat === false) {
      onChange(name, momentDate.format("YYYY/MM/DD"));
      setKey((preKey) => preKey + 1);
      return;
    }
    onChange(name, momentDate.format("YYYY/MM/DD HH:mm"));
    setKey((preKey) => preKey + 1);
  };

  return (
    <div className="relative w-fit">
      <div className="absolute right-2 top-1/2 transform -translate-y-1/2 z-10 flex items-center">
        <img
          onClick={(e) => {document.getElementById(id).focus()}}
          src={calendarIcon}
          className="w-[18px] h-[18px] cursor-pointer"
          alt="icon-calendar"
        />
      </div>
      <Datetime
        key={key}
        value={value}
        renderInput={showClearButton ? renderInput : null}
        input={true}
        onChange={(e) => {handleChange(e)}}
        dateFormat="YYYY/MM/DD"
        timeFormat={rest.timeFormat === false ? rest.timeFormat : "HH:mm"}
        locale="ja"
        closeOnSelect={true}
        inputProps={{
          className: inputClass,
          name: name ? name : null,
          id: id ? id : null,
          readOnly: true,
          disabled: disabled,
          maxLength: maxLength ? maxLength : null,
          onKeyDown: () => {
            return false;
          },
          onKeyUp: () => {
            return false;
          },
          onKeyPress: () => {
            return false;
          },
          onInput: () => {
            return false;
          },
        }}
        renderView={(mode, renderDefault) => {
          return (
            <div>
              {renderDefault()}
              {mode === 'days' &&
                <Button theme={tenkenTheme.button}
                        color="gray"
                        className="rounded-[4px] mx-auto my-[4px] w-[120px] !bg-[#D2D5DA] hover:!bg-[#9CA3AF]"
                        onClick={handleSetToday} >
                  本日
                </Button>
              }
            </div>
          );
        }}
      />
    </div>
  );
};

export default DatetimePicker;
